import React, { useState, useEffect } from "react";
import {
  Card,
  Box,
  Button,
  Grid,
  Stack,
  TextField,
  Autocomplete,
  Typography,
} from "@mui/material";
import Header from "../components/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { decryptPayload } from "../utils/custom-hash";
import FourZeroFour from "../errors/404"
import dayjs from "dayjs";

function CustomerForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const [branchStatus, setBranchStatus] = useState('open');
  const [services, setServices] = useState([]);
  const [branchId, setBranchId] = useState(null);
  const [branchDetails, setBranchDetails] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  // const [fetchedCounters, setFetchedCounters] = useState([]);
  // const [selectedCounter, setSelectedCounter] = useState(null);
  const [ticketNumber, setTicketNumber] = useState("");
  const { encryptPayload } = require("../utils/custom-hash");
  const [errorMessage, setErrorMessage] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const fetchData = async () => {
      const queryParams = new URLSearchParams(location.search);
      const token = queryParams.get("token");
     // console.log("Received Token: ", token);

      try {
        const decryptedBranchId = await decryptPayload(token); // Ensure `decryptPayload` and `generateKey` match the encryption logic
       // console.log("Decrypted Branch ID:", decryptedBranchId);

        if (decryptedBranchId) {
          setBranchId(decryptedBranchId);
          localStorage.setItem("branchId", decryptedBranchId);

          // Fetch services based on the decrypted branch ID
          const fetchServices = async () => {
            try {
              const response = await fetch(`${process.env.REACT_APP_ASERVER}/api/kiosk/services/${decryptedBranchId}`, {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              });

              if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

              const data = await response.json();
              if (data.success && data.services) {
                setServices(data.services);
              } else {
                console.error("Failed to fetch services: ", data.message || "Unknown error");
              }
            } catch (error) {
              console.error("Error fetching services:", error);
            }
          };

          fetchServices();
        }
      } catch (error) {
        console.error("Error decrypting payload:", error);
      }
    };

    fetchData();
  }, [location]);

  useEffect(() => {
    const fetchBranchDetails = async () => {
      if (branchId) {

        try {
          const response = await fetch(`${process.env.REACT_APP_ASERVER}/api/kiosk/branches/${branchId}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });

          if (!response.ok) throw new Error("Network response was not ok");

          const result = await response.json();
          setBranchDetails(result.branch);
          if (response.ok) {
            // Log open and closed times for debugging
            // console.log("Open Time:", result.branch.openTime);
            // console.log("Closed Time:", result.branch.closedTime);

            if (result.branch.openTime && result.branch.closedTime) {
              // Parse branch opening and closing times without specifying a format
              const openTime = dayjs(result.branch.openTime);
              const closedTime = dayjs(result.branch.closedTime);
              const currentTime = dayjs();  // Get the current time

              // console.log("Parsed Open Time:", openTime);
              // console.log("Parsed Closed Time:", closedTime);
              // console.log("Current Time:", currentTime);

              if (openTime.isValid() && closedTime.isValid()) {
                // Check if branch is currently open or closed
                if (currentTime.isAfter(openTime) && currentTime.isBefore(closedTime)) {
                  setBranchStatus('open');
                } else {
                  alert("The branch is currently closed.");
                  setBranchStatus('closed');
                }
              } else {
                console.error("Invalid date format for openTime or closedTime.");
              }
            } else {
              console.error("Branch openTime or closedTime is undefined.");
            }
          }

        } catch (error) {
          console.error("Error fetching branch details:", error);
          // setBranchStatus('closed')
          alert("Failed to fetch branch details.");
        }
      }
    };

    fetchBranchDetails();
  }, [branchId]);


  // useEffect(() => {
  //   const fetchCounters = async (serviceId, branchId) => {
  //     if (serviceId && branchId) {
  //       try {
  //         const response = await fetch(`${process.env.REACT_APP_ASERVER}/api/kiosk/counters/${branchId}/${serviceId}`, {
  //           method: "GET",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         });

  //         if (!response.ok) throw new Error("Failed to fetch counters");

  //         const result = await response.json();
  //         setFetchedCounters(result.counter);

  //         if (result.counter.length === 1) {
  //           setSelectedCounter(result.counter[0]);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching counters:", error);
  //         alert("For this service, Counter is currently unavailable.");
  //       }
  //     }
  //   };

  //   fetchCounters(selectedService?.serviceId, branchId);


  // }, [selectedService, branchId]);

  const [serviceError, setServiceError] = useState("");

  const [key, setKey] = useState(0);

  const handleServiceChange = (event, newValue) => {
    if (newValue && !newValue.isActive) {
      setServiceError(`Service is currently unavailable and will be available from ${newValue.startTime} to ${newValue.endTime}.`);
      setSelectedService(null);

      // Reset component by changing key
      setKey(prev => prev + 1);
    } else {
      setServiceError("");
      setSelectedService(newValue);
    }
  };

  useEffect(() => {
    if (!selectedService) {
      setSelectedService(null); // Force re-render
    }
  }, [selectedService]);


  useEffect(() => {
    if (!selectedService) {
      setSelectedService(null); // Force re-render
    }
  }, [selectedService]);


  const onSubmit = async (data) => {
    try {
      setErrorMessage("");

      // Prepare the first payload for ticket generation
      const ticketPayload = {
        branchId,
        serviceId: selectedService?.serviceId,
        customerName: data.name,
        customerMail: data.email,
        customerContact: data.contactNumber,
        // counterId: selectedCounter ? selectedCounter.counterId : null,
        customerType: "walk-in",
      };

      const encryptedticketPayload = await encryptPayload(ticketPayload);
      //console.log("Encrypted Branch ID:", encryptedticketPayload);

      // Call the API to generate the ticket
      const ticketResponse = await fetch(`${process.env.REACT_APP_ASERVER}/api/kiosk/ticket/generate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ encryptedPayload: encryptedticketPayload }),
      });

      if (!ticketResponse.ok) {
        const errorData = await ticketResponse.json(); // Parse the error message
        setErrorMessage(errorData.message || "Failed to generate ticket"); // Update error message state
        return; // Exit the function if there is an error
      }
      const ticketResult = await ticketResponse.json();
      setTicketNumber(ticketResult.ticket);

      // Prepare the payload for printing the ticket
      const printPayload = {
        ticketNumber: ticketResult.ticket,
        branchId: branchDetails.branchId,
      };
      // console.log("ticketNumber ID:", ticketNumber);
      // console.log("Branch ID:", branchId);
      const encryptedprintPayload = await encryptPayload(printPayload);
      //console.log("Encrypted Branch ID:", encryptedprintPayload);

      // Call the API to print the ticket
      const printResponse = await fetch(`${process.env.REACT_APP_ASERVER}/api/kiosk/ticket/print`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ encryptedPayload: encryptedprintPayload }),
      });

      if (!printResponse.ok) throw new Error("Network response was not ok");

      const printResult = await printResponse.json();

      if (printResult.success) {
        const ticketResult = decryptPayload(printResult.ticket);
        //console.log('@@@ Print ticketData--', ticketResult);
        // Prepare the payload for the customer view
        const printDetails = {
          tokenNumber: ticketResult.ticketId,
          token: ticketResult.token,
          branch: ticketResult.branch,
          estimatedWaitingTime: ticketResult.estimatedWaitingTime,
          branchContact: ticketResult.branchContact,
          status: ticketResult.status,
          issueTime: ticketResult.issueTime,
          serviceName: ticketResult.serviceName,
          // counterName: printResult.ticket.counterName,
          customerName: ticketResult.customerName,
          customerEmail: ticketResult.customerEmail,
          customerContact: ticketResult.customerContact,
        };

        // Navigate to the customer view with the ticket details
        navigate("/qr-ticket-generator/customer-view", { state: { ticketDetails: printDetails } });
        reset();
      }
    } catch (error) {
      console.error("Error generating ticket:", error);
      setErrorMessage(
        error.message || "Error generating ticket. Please try again later."
      );
      // alert("Error generating ticket. Please try again later.");
    }
  };





  return (

    <Box
      sx={{
        minHeight: "125vh",
        width: "100%",
        backgroundColor: "#f0f2f5",
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
      }}
    >
      <Header />
      {branchStatus == 'open' ? (
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            padding: 0,
          }}
        >
          <Card
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0)",
              height: "auto",
              boxShadow: "none",
            }}
          >
            <Box
              sx={{
                paddingLeft: { xs: 2, sm: 10, md: 20 },
                paddingRight: { xs: 2, sm: 10, md: 20 },
                flexGrow: 1,
              }}
            >
              <Grid container spacing={3} sx={{ width: "100%", backgroundColor: "#F0F2F5", padding: { xs: 2, sm: 4, md: 6 } }}>

                {/* Branch Name Card */}
                <Grid item xs={12} mt={4}>
                  <Card sx={{ maxWidth: "900px", margin: "auto", padding: 3, borderRadius: 2, boxShadow: 3 }}>
                    <Typography variant="h5" align="center">
                      {branchDetails?.branchName || "Branch Name"}
                    </Typography>
                  </Card>
                </Grid>

                {/* Form Card */}
                <Grid item xs={12} mt={2}>
                  <Card sx={{ maxWidth: "870px", margin: "auto", padding: { xs: 3, sm: 5 }, borderRadius: 2, boxShadow: 3 }}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <Grid container spacing={3}>

                        {/* Select Service */}
                        {/* <Grid item xs={12} sm={6}>
                          <Autocomplete
                            value={selectedService}
                            onChange={(event, newValue) => setSelectedService(newValue)}
                            options={services}
                            getOptionLabel={(option) => option.serviceName}
                            renderInput={(params) => <TextField {...params} label="Select Service" variant="outlined" />}
                            fullWidth
                          />
                        </Grid> */}

                        <Grid item xs={12} sm={6}>
                          {/* <Autocomplete
                            options={services}
                            getOptionLabel={(option) => option.serviceName || ""}
                            value={selectedService || null} // Make sure it reflects null when needed
                            onChange={handleServiceChange}
                            isOptionEqualToValue={(option, value) => option?.serviceId === value?.serviceId} // Ensure proper comparison
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Service"
                                variant="outlined"
                                fullWidth
                                error={!!serviceError}
                                helperText={serviceError}
                              />
                            )}
                          /> */}


                          <Autocomplete
                            key={key} // Forces re-render
                            options={services}
                            getOptionLabel={(option) => option?.serviceName || ""}
                            value={selectedService}
                            onChange={handleServiceChange}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Service"
                                variant="outlined"
                                error={!!serviceError}
                                helperText={serviceError}
                              />
                            )}
                          />


                        </Grid>

                        {/* Customer Name */}
                        <Grid item xs={12} sm={6}>
                          <TextField
                            {...register("name", { required: "Name is required" })}
                            label="Customer Name"
                            variant="outlined"
                            fullWidth
                            error={!!errors.name}
                            helperText={errors.name ? errors.name.message : ""}
                          />
                        </Grid>

                        {/* Email */}
                        <Grid item xs={12} sm={6}>
                          <TextField
                         {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                            message: "Enter a valid email address",
                          },
                        })}
                            label="Email"
                            variant="outlined"
                            fullWidth
                            error={!!errors.email}
                            helperText={errors.email ? errors.email.message : ""}
                          />
                        </Grid>

                        {/* Contact Number */}
                          <Grid item xs={12} sm={6}>
                                                      <TextField
                                                        {...register("contactNumber", {
                                                          required: "Contact Number is required",
                                                          validate: (value) => {
                                                            // if (/^1/.test(value)) {
                                                            //   return /^[0-9]{11}$/.test(value) || "Enter a valid 11-digit phone number starting with 1";
                                                            // } else {
                                                              return /^[0-9]{10}$/.test(value) || "Enter a valid 10-digit phone number";
                                                            // }
                                                          },
                                                        })}
                                                        label="Phone Number"
                                                        variant="outlined"
                                                        fullWidth
                                                        error={!!errors.contactNumber}
                                                        helperText={errors.contactNumber?.message}
                                                      />
                                                    </Grid>
                  

                        {/* Error Message Display */}
                        {errorMessage && (
                          <Grid item xs={12}>
                            <Typography color="error" textAlign="center">
                              {errorMessage}
                            </Typography>
                          </Grid>
                        )}

                        {/* Submit Button */}
                        <Grid item xs={12} display="flex" justifyContent="center">
                          <Button type="submit" variant="contained" size="large">Submit</Button>
                        </Grid>

                      </Grid>
                    </form>
                  </Card>
                </Grid>

              </Grid>

            </Box>
          </Card>
        </Box>
      ) : (
        <FourZeroFour />
      )}


    </Box>
  );
}

export default CustomerForm;